import { cn, getOpenings, useI18n } from "@jog/react-components"
import type { JoggStore } from "@jog/types"
import { useMemo } from "react"

export const Opening = ({ store, showOpenings }: { store: Pick<JoggStore, "openings">; showOpenings?: boolean }) => {
    const { $t } = useI18n()
    const openings = useMemo(() => getOpenings(store.openings), [store.openings])
    const today = openings.find((opening) => opening.isToday)
    return (
        <>
            {today?.isOpen === "opening" ? (
                <p className="text-green-dark">
                    {$t("Open today from {opens} to {closes}", { opens: today.opens, closes: today.closes })}
                </p>
            ) : today?.isOpen === "ready" ? (
                <p className="text-red-base">{$t("Closed at the moment, opens at {opens}", { opens: today.opens })}</p>
            ) : today?.isOpen === "closed" ? (
                <p className="text-red-base">{$t("Closed today")}</p>
            ) : (
                <></>
            )}
            {showOpenings ? (
                <div className="mt-6">
                    {openings.map((opening) => (
                        <p
                            key={opening.dayOfWeek}
                            className={cn("flex max-w-[300px] items-center justify-between", {
                                "font-semibold": opening.isToday,
                            })}>
                            <span>{$t(opening.dayOfWeek)}</span>
                            <span className={cn("inline-block w-32", { "text-red-base": opening.status === "closed" })}>
                                {opening.opens ? `${opening.opens} - ${opening.closes}` : $t("Closed")}
                            </span>
                        </p>
                    ))}
                </div>
            ) : (
                <></>
            )}
        </>
    )
}
